export default __webpack_public_path__ + "static/190-7c9c88418a8986cc06dd5b38968a6210.jpg";